export default __webpack_public_path__ + "static/media/01_Eschweiler_photographer_Esche_Serum114_Architecture_Interieur_1.3ddfc94d.jpg";